var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSpecial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7028 1.1055C11.4503 0.468469 12.5497 0.468468 13.2972 1.1055L15.181 2.71082C15.5013 2.98381 15.8996 3.14878 16.3191 3.18226L18.7863 3.37914C19.7653 3.45727 20.5427 4.23469 20.6209 5.21371L20.8177 7.68086C20.8512 8.1004 21.0162 8.49868 21.2892 8.819L22.8945 10.7028C23.5315 11.4503 23.5315 12.5497 22.8945 13.2972L21.2892 15.181C21.0162 15.5013 20.8512 15.8996 20.8177 16.3191L20.6209 18.7863C20.5427 19.7653 19.7653 20.5427 18.7863 20.6209L16.3191 20.8177C15.8996 20.8512 15.5013 21.0162 15.181 21.2892L13.2972 22.8945C12.5497 23.5315 11.4503 23.5315 10.7028 22.8945L8.819 21.2892C8.49868 21.0162 8.1004 20.8512 7.68086 20.8177L5.21371 20.6209C4.23469 20.5427 3.45727 19.7653 3.37914 18.7863L3.18226 16.3191C3.14878 15.8996 2.98381 15.5013 2.71082 15.181L1.1055 13.2972C0.468469 12.5497 0.468468 11.4503 1.1055 10.7028L2.71082 8.819C2.98381 8.49868 3.14878 8.1004 3.18226 7.68086L3.37914 5.21371C3.45727 4.23469 4.23469 3.45727 5.21371 3.37914L7.68086 3.18226C8.1004 3.14878 8.49868 2.98381 8.819 2.71082L10.7028 1.1055Z",
    fill: "#23C65E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7028 1.1055C11.4503 0.468469 12.5497 0.468468 13.2972 1.1055L15.181 2.71082C15.5013 2.98381 15.8996 3.14878 16.3191 3.18226L18.7863 3.37914C19.7653 3.45727 20.5427 4.23469 20.6209 5.21371L20.8177 7.68086C20.8512 8.1004 21.0162 8.49868 21.2892 8.819L22.8945 10.7028C23.5315 11.4503 23.5315 12.5497 22.8945 13.2972L21.2892 15.181C21.0162 15.5013 20.8512 15.8996 20.8177 16.3191L20.6209 18.7863C20.5427 19.7653 19.7653 20.5427 18.7863 20.6209L16.3191 20.8177C15.8996 20.8512 15.5013 21.0162 15.181 21.2892L13.2972 22.8945C12.5497 23.5315 11.4503 23.5315 10.7028 22.8945L8.819 21.2892C8.49868 21.0162 8.1004 20.8512 7.68086 20.8177L5.21371 20.6209C4.23469 20.5427 3.45727 19.7653 3.37914 18.7863L3.18226 16.3191C3.14878 15.8996 2.98381 15.5013 2.71082 15.181L1.1055 13.2972C0.468469 12.5497 0.468468 11.4503 1.1055 10.7028L2.71082 8.819C2.98381 8.49868 3.14878 8.1004 3.18226 7.68086L3.37914 5.21371C3.45727 4.23469 4.23469 3.45727 5.21371 3.37914L7.68086 3.18226C8.1004 3.14878 8.49868 2.98381 8.819 2.71082L10.7028 1.1055Z",
    fill: "url(#paint0_linear_151_7765)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9L10.5 15L7.5 12",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_151_7765",
    x1: 0,
    y1: 0,
    x2: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FDD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FDD78",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSpecial);
export default __webpack_public_path__ + "static/media/check-special.9ce3940c7cf30554110d235b925a2ac1.svg";
export { ForwardRef as ReactComponent };